// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/admin.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * AdminWorkspace represents a workspace with admin-level details
 *
 * @generated from message omnios.v1.AdminWorkspace
 */
export const AdminWorkspace = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdminWorkspace",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "plan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "product_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "order_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "member_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "storage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "suspended_at", kind: "message", T: Timestamp },
    { no: 13, name: "suspended_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "features", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "settings", kind: "message", T: Struct },
  ],
);

/**
 * AdminUser represents a user with cross-workspace details
 *
 * @generated from message omnios.v1.AdminUser
 */
export const AdminUser = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdminUser",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "workspaces", kind: "message", T: UserWorkspaceMembership, repeated: true },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "last_seen_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.UserWorkspaceMembership
 */
export const UserWorkspaceMembership = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UserWorkspaceMembership",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "joined_at", kind: "message", T: Timestamp },
  ],
);

/**
 * UsageMetrics provides platform-wide analytics
 *
 * @generated from message omnios.v1.UsageMetrics
 */
export const UsageMetrics = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UsageMetrics",
  () => [
    { no: 1, name: "total_workspaces", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "active_workspaces", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_users", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "total_products", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_orders", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "total_storage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "workspace_growth", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 8, name: "user_growth", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 9, name: "total_po_rows", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "total_catalog_rows", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.TimeSeriesPoint
 */
export const TimeSeriesPoint = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TimeSeriesPoint",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * AuditLogEntry represents an admin action
 *
 * @generated from message omnios.v1.AuditLogEntry
 */
export const AuditLogEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AuditLogEntry",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "admin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "admin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "details", kind: "message", T: Struct },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListAllWorkspacesRequest
 */
export const ListAllWorkspacesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllWorkspacesRequest",
  () => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAllWorkspacesResponse
 */
export const ListAllWorkspacesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllWorkspacesResponse",
  () => [
    { no: 1, name: "workspaces", kind: "message", T: AdminWorkspace, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceDetailsRequest
 */
export const GetWorkspaceDetailsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceDetailsRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PipelineUsageStats
 */
export const PipelineUsageStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PipelineUsageStats",
  () => [
    { no: 1, name: "pipeline_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_runs", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "completed_runs", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "failed_runs", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_rows_processed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "last_run_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.WorkspaceRole
 */
export const WorkspaceRole = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkspaceRole",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceDetailsResponse
 */
export const GetWorkspaceDetailsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceDetailsResponse",
  () => [
    { no: 1, name: "workspace", kind: "message", T: AdminWorkspace },
    { no: 2, name: "product_growth", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 3, name: "order_growth", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 4, name: "storage_growth", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 5, name: "pipeline_usage", kind: "message", T: PipelineUsageStats, repeated: true },
    { no: 6, name: "roles", kind: "message", T: WorkspaceRole, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AdminCreateWorkspaceRequest
 */
export const AdminCreateWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdminCreateWorkspaceRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "features", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "settings", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.AdminUpdateWorkspaceRequest
 */
export const AdminUpdateWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdminUpdateWorkspaceRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "plan", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "features", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "settings", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.SuspendWorkspaceRequest
 */
export const SuspendWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuspendWorkspaceRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReactivateWorkspaceRequest
 */
export const ReactivateWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReactivateWorkspaceRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAllUsersRequest
 */
export const ListAllUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllUsersRequest",
  () => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAllUsersResponse
 */
export const ListAllUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: AdminUser, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetUsageMetricsRequest
 */
export const GetUsageMetricsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetUsageMetricsRequest",
  () => [
    { no: 1, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetUsageMetricsResponse
 */
export const GetUsageMetricsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetUsageMetricsResponse",
  () => [
    { no: 1, name: "metrics", kind: "message", T: UsageMetrics },
  ],
);

/**
 * @generated from message omnios.v1.GenerateInviteLinkRequest
 */
export const GenerateInviteLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateInviteLinkRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expires_in_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GenerateInviteLinkResponse
 */
export const GenerateInviteLinkResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateInviteLinkResponse",
  () => [
    { no: 1, name: "invite_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expires_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListAuditLogRequest
 */
export const ListAuditLogRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAuditLogRequest",
  () => [
    { no: 1, name: "admin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAuditLogResponse
 */
export const ListAuditLogResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAuditLogResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: AuditLogEntry, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ImpersonateRequest
 */
export const ImpersonateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImpersonateRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duration_minutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ImpersonateResponse
 */
export const ImpersonateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImpersonateResponse",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expires_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Feature definition
 *
 * @generated from message omnios.v1.Feature
 */
export const Feature = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Feature",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "impact", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "plugins", kind: "message", T: FeaturePlugin, repeated: true },
  ],
);

/**
 * Plugin linked to a feature
 *
 * @generated from message omnios.v1.FeaturePlugin
 */
export const FeaturePlugin = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FeaturePlugin",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plugin_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plugin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_installed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Feature status for a workspace
 *
 * @generated from message omnios.v1.WorkspaceFeatureStatus
 */
export const WorkspaceFeatureStatus = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkspaceFeatureStatus",
  () => [
    { no: 1, name: "feature", kind: "message", T: Feature },
    { no: 2, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "enabled_at", kind: "message", T: Timestamp },
    { no: 4, name: "enabled_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "granted_by_plan", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListFeaturesRequest
 */
export const ListFeaturesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFeaturesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListFeaturesResponse
 */
export const ListFeaturesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFeaturesResponse",
  () => [
    { no: 1, name: "features", kind: "message", T: Feature, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceFeaturesRequest
 */
export const GetWorkspaceFeaturesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceFeaturesRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceFeaturesResponse
 */
export const GetWorkspaceFeaturesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceFeaturesResponse",
  () => [
    { no: 1, name: "features", kind: "message", T: WorkspaceFeatureStatus, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetWorkspaceFeatureRequest
 */
export const SetWorkspaceFeatureRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetWorkspaceFeatureRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.SetWorkspaceFeatureResponse
 */
export const SetWorkspaceFeatureResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetWorkspaceFeatureResponse",
  () => [
    { no: 1, name: "feature", kind: "message", T: WorkspaceFeatureStatus },
  ],
);

/**
 * @generated from message omnios.v1.LinkPluginToFeatureRequest
 */
export const LinkPluginToFeatureRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.LinkPluginToFeatureRequest",
  () => [
    { no: 1, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.LinkPluginToFeatureResponse
 */
export const LinkPluginToFeatureResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.LinkPluginToFeatureResponse",
  () => [
    { no: 1, name: "feature", kind: "message", T: Feature },
  ],
);

/**
 * @generated from message omnios.v1.UnlinkPluginFromFeatureRequest
 */
export const UnlinkPluginFromFeatureRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UnlinkPluginFromFeatureRequest",
  () => [
    { no: 1, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UnlinkPluginFromFeatureResponse
 */
export const UnlinkPluginFromFeatureResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UnlinkPluginFromFeatureResponse",
  () => [
    { no: 1, name: "feature", kind: "message", T: Feature },
  ],
);

/**
 * @generated from message omnios.v1.CreateFeatureRequest
 */
export const CreateFeatureRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateFeatureRequest",
  () => [
    { no: 1, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "impact", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateFeatureResponse
 */
export const CreateFeatureResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateFeatureResponse",
  () => [
    { no: 1, name: "feature", kind: "message", T: Feature },
  ],
);

/**
 * @generated from message omnios.v1.BillingPlan
 */
export const BillingPlan = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BillingPlan",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "trial_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "prices", kind: "message", T: BillingPlanPrice, repeated: true },
    { no: 9, name: "grants", kind: "message", T: PlanGrant, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BillingPlanPrice
 */
export const BillingPlanPrice = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BillingPlanPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "base_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "per_seat_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "included_seats", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PlanGrant
 */
export const PlanGrant = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PlanGrant",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "plugin_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "grant_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "included_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "overage_unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.BillingMetricInfo
 */
export const BillingMetricInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BillingMetricInfo",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.Subscription
 */
export const Subscription = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Subscription",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "plan_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "current_period_start", kind: "message", T: Timestamp },
    { no: 10, name: "current_period_end", kind: "message", T: Timestamp },
    { no: 11, name: "trial_end", kind: "message", T: Timestamp },
    { no: 12, name: "canceled_at", kind: "message", T: Timestamp },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "overrides", kind: "message", T: SubscriptionOverride, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SubscriptionOverride
 */
export const SubscriptionOverride = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SubscriptionOverride",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plugin_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "included_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "overage_unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.Invoice
 */
export const Invoice = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Invoice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "invoice_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "subtotal", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "tax_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "period_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "period_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "line_items", kind: "message", T: InvoiceLineItem, repeated: true },
    { no: 15, name: "payments", kind: "message", T: Payment, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.InvoiceLineItem
 */
export const InvoiceLineItem = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InvoiceLineItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.Payment
 */
export const Payment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Payment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reference_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.MetricUsage
 */
export const MetricUsage = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MetricUsage",
  () => [
    { no: 1, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metric_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "grant_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "included_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "current_usage", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "overage_unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.FeatureEntitlement
 */
export const FeatureEntitlement = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FeatureEntitlement",
  () => [
    { no: 1, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "granted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.WorkspaceEntitlements
 */
export const WorkspaceEntitlements = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkspaceEntitlements",
  () => [
    { no: 1, name: "features", kind: "message", T: FeatureEntitlement, repeated: true },
    { no: 2, name: "metrics", kind: "message", T: MetricUsage, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceSubscriptionRequest
 */
export const GetWorkspaceSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceSubscriptionRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceSubscriptionResponse
 */
export const GetWorkspaceSubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceSubscriptionResponse",
  () => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ],
);

/**
 * @generated from message omnios.v1.CreateSubscriptionRequest
 */
export const CreateSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSubscriptionRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateSubscriptionResponse
 */
export const CreateSubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSubscriptionResponse",
  () => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ],
);

/**
 * @generated from message omnios.v1.UpdateSubscriptionRequest
 */
export const UpdateSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateSubscriptionRequest",
  () => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_slug", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateSubscriptionResponse
 */
export const UpdateSubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateSubscriptionResponse",
  () => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ],
);

/**
 * @generated from message omnios.v1.CancelSubscriptionRequest
 */
export const CancelSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelSubscriptionRequest",
  () => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelSubscriptionResponse
 */
export const CancelSubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelSubscriptionResponse",
  () => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ],
);

/**
 * @generated from message omnios.v1.AddSubscriptionOverrideRequest
 */
export const AddSubscriptionOverrideRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddSubscriptionOverrideRequest",
  () => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plugin_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "included_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "overage_unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AddSubscriptionOverrideResponse
 */
export const AddSubscriptionOverrideResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddSubscriptionOverrideResponse",
  () => [
    { no: 1, name: "override", kind: "message", T: SubscriptionOverride },
  ],
);

/**
 * @generated from message omnios.v1.RemoveSubscriptionOverrideRequest
 */
export const RemoveSubscriptionOverrideRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemoveSubscriptionOverrideRequest",
  () => [
    { no: 1, name: "override_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RemoveSubscriptionOverrideResponse
 */
export const RemoveSubscriptionOverrideResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemoveSubscriptionOverrideResponse",
  [],
);

/**
 * @generated from message omnios.v1.ListInvoicesRequest
 */
export const ListInvoicesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInvoicesRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListInvoicesResponse
 */
export const ListInvoicesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInvoicesResponse",
  () => [
    { no: 1, name: "invoices", kind: "message", T: Invoice, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetInvoiceRequest
 */
export const GetInvoiceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetInvoiceRequest",
  () => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetInvoiceResponse
 */
export const GetInvoiceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetInvoiceResponse",
  () => [
    { no: 1, name: "invoice", kind: "message", T: Invoice },
  ],
);

/**
 * @generated from message omnios.v1.GenerateInvoiceRequest
 */
export const GenerateInvoiceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateInvoiceRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GenerateInvoiceResponse
 */
export const GenerateInvoiceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateInvoiceResponse",
  () => [
    { no: 1, name: "invoice", kind: "message", T: Invoice },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeInvoiceRequest
 */
export const FinalizeInvoiceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeInvoiceRequest",
  () => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeInvoiceResponse
 */
export const FinalizeInvoiceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeInvoiceResponse",
  () => [
    { no: 1, name: "invoice", kind: "message", T: Invoice },
  ],
);

/**
 * @generated from message omnios.v1.RecordPaymentRequest
 */
export const RecordPaymentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RecordPaymentRequest",
  () => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reference_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RecordPaymentResponse
 */
export const RecordPaymentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RecordPaymentResponse",
  () => [
    { no: 1, name: "payment", kind: "message", T: Payment },
  ],
);

/**
 * @generated from message omnios.v1.VoidInvoiceRequest
 */
export const VoidInvoiceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VoidInvoiceRequest",
  () => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.VoidInvoiceResponse
 */
export const VoidInvoiceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VoidInvoiceResponse",
  () => [
    { no: 1, name: "invoice", kind: "message", T: Invoice },
  ],
);

/**
 * @generated from message omnios.v1.ChargeInvoiceRequest
 */
export const ChargeInvoiceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ChargeInvoiceRequest",
  () => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ChargeInvoiceResponse
 */
export const ChargeInvoiceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ChargeInvoiceResponse",
  () => [
    { no: 1, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "client_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.SetBillingPaymentMethodRequest
 */
export const SetBillingPaymentMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetBillingPaymentMethodRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetBillingPaymentMethodResponse
 */
export const SetBillingPaymentMethodResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetBillingPaymentMethodResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetWorkspaceUsageRequest
 */
export const GetWorkspaceUsageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceUsageRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceUsageResponse
 */
export const GetWorkspaceUsageResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceUsageResponse",
  () => [
    { no: 1, name: "metrics", kind: "message", T: MetricUsage, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceEntitlementsRequest
 */
export const GetWorkspaceEntitlementsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceEntitlementsRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceEntitlementsResponse
 */
export const GetWorkspaceEntitlementsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceEntitlementsResponse",
  () => [
    { no: 1, name: "entitlements", kind: "message", T: WorkspaceEntitlements },
  ],
);

/**
 * @generated from message omnios.v1.ListBillingPlansRequest
 */
export const ListBillingPlansRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBillingPlansRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListBillingPlansResponse
 */
export const ListBillingPlansResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBillingPlansResponse",
  () => [
    { no: 1, name: "plans", kind: "message", T: BillingPlan, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateBillingPlanRequest
 */
export const CreateBillingPlanRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateBillingPlanRequest",
  () => [
    { no: 1, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "trial_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateBillingPlanResponse
 */
export const CreateBillingPlanResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateBillingPlanResponse",
  () => [
    { no: 1, name: "plan", kind: "message", T: BillingPlan },
  ],
);

/**
 * @generated from message omnios.v1.UpdateBillingPlanRequest
 */
export const UpdateBillingPlanRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateBillingPlanRequest",
  () => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "is_public", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "trial_days", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateBillingPlanResponse
 */
export const UpdateBillingPlanResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateBillingPlanResponse",
  () => [
    { no: 1, name: "plan", kind: "message", T: BillingPlan },
  ],
);

/**
 * @generated from message omnios.v1.GetBillingPlanRequest
 */
export const GetBillingPlanRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBillingPlanRequest",
  () => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetBillingPlanResponse
 */
export const GetBillingPlanResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBillingPlanResponse",
  () => [
    { no: 1, name: "plan", kind: "message", T: BillingPlan },
    { no: 2, name: "grants", kind: "message", T: PlanGrant, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetPlanGrantRequest
 */
export const SetPlanGrantRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetPlanGrantRequest",
  () => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plugin_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "grant_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "included_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "overage_unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.SetPlanGrantResponse
 */
export const SetPlanGrantResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetPlanGrantResponse",
  () => [
    { no: 1, name: "grant", kind: "message", T: PlanGrant },
  ],
);

/**
 * @generated from message omnios.v1.RemovePlanGrantRequest
 */
export const RemovePlanGrantRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemovePlanGrantRequest",
  () => [
    { no: 1, name: "grant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RemovePlanGrantResponse
 */
export const RemovePlanGrantResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemovePlanGrantResponse",
  [],
);

/**
 * @generated from message omnios.v1.SetPlanPriceRequest
 */
export const SetPlanPriceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetPlanPriceRequest",
  () => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "per_seat_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "included_seats", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SetPlanPriceResponse
 */
export const SetPlanPriceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetPlanPriceResponse",
  () => [
    { no: 1, name: "price", kind: "message", T: BillingPlanPrice },
  ],
);

/**
 * @generated from message omnios.v1.ListBillingMetricsRequest
 */
export const ListBillingMetricsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBillingMetricsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListBillingMetricsResponse
 */
export const ListBillingMetricsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBillingMetricsResponse",
  () => [
    { no: 1, name: "metrics", kind: "message", T: BillingMetricInfo, repeated: true },
  ],
);

